<template>
  <BaseModal
    ref="modal"
    modal-classes="max-w-md mx-auto mt-16"
    @modal-after-leave="$emit('closed')"
  >
    <template #header>
      <h3 class="text-2xl text-gray-900">Edit form</h3>
    </template>

    <template #default="modalProps">
      <FormForm :submit-action="submitAction" :default-data="form" @cancel="modalProps.close" />
    </template>
  </BaseModal>
</template>

<script>
import { mapActions } from 'vuex';
import FormForm from '@/components/Forms/Form.vue';

export default {
  components: {
    FormForm,
  },

  props: {
    form: { type: Object, required: true },
  },

  methods: {
    ...mapActions('ui/forms', {
      updateForm: 'update',
    }),
    submitAction(formData) {
      const { uuid: formUuid } = this.form;

      return this.updateForm({ formUuid, formData })
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
